module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "prf2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _vm._v("PREFACE"), _c('br'), _c('em', [_vm._v("Anton")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("KNOW")]), _vm._v(" where the path to the stars lies. The gate opened once, a long time ago and in a far and unlikely place. And then it closed. This is the story of how it opened and of how it closed and perhaps of what hinged upon it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You see, Sharon Nagy was a physicist and Tom Schwoerin was a cliologist. That was the heart of the business right there. That was the beginning of it and the end of it and most of what happened in between.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Or perhaps you don’t, for the seeing was not easy. Medieval settlement patterns and multiple brane theory seem worlds apart. Indeed, they "), _c('em', [_vm._v("are")]), _vm._v(" worlds apart, tangent only in that small apartment in Philadelphia that Tom and Sharon shared. But at such close quarters they could not avoid learning a little of each other’s work, and that was the fulcrum on which they turned the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But I was into the affair last and least of all, and perhaps it would be best to let the story tell itself.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4250b17f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780765340351_epub_prf2_r1.vue
// module id = 90
// module chunks = 0